import { createContext } from 'react';
import { TaskContextType } from './types';

const TaskContext = createContext<TaskContextType | undefined>(undefined);

export default TaskContext;
